import { TDao } from "~/_types/TDao";
import { ECode } from "../../_enums/ECode";
import { TApiConfig } from "../../_libs/fetch/fetchConfig";
import { fetchGetJson } from "../../_libs/fetch/fetchGetJson";

type TGetDaosInputDto = {
  subdomain?: string;
  search?: string;
};

type TGetDaosOutputDto = {
  code: ECode;
  data: Array<TDao>;
};

async function getDaos(
  params: TGetDaosInputDto,
  config: TApiConfig,
): Promise<TGetDaosOutputDto> {
  const searchParams = new URLSearchParams(params);
  const query = searchParams.toString();

  return fetchGetJson("/daos", { query: query ? `?${query}` : query }, config);
}

export { getDaos };
